import { ISelectOption } from '../interfaces/select-option.interface';

export const VERTICAL_POSITION_OPTIONS: ISelectOption[] = [
  { key: 'top', name: 'Top' },
  { key: 'bottom', name: 'Bottom' },
];
